export default {
    AdminRequireVerifyCode: 'admin.login-require-verify-code',
    AdminRetryRequireVerifyCode: 'admin.retry-login-require-verify-code',
    AdminRequireRealPersonVerify: 'admin.login-require-real-person-verify',
    AdminPwdLevel1: 'admin.enable-pwd-level-1',
    AdminPwdLevel2: 'admin.enable-pwd-level-2',
    AdminPwdLevel3: 'admin.enable-pwd-level-3',
    AdminPwdMinLen: 'admin.pwd-min-len',
    AdminPwdMaxLen: 'admin.pwd-max-len',
    AdminPwdExpireDays: 'admin.pwd-expire-days',
    AdminPwdDisRegular: 'admin.pwd-disable-regular',
    AdminPwdDisCommon: 'admin.pwd-disable-common',
    AdminPwdDisBirthday: 'admin.pwd-disable-birthday',
};
